const initialState = {
    anchor: 'left',
    cidade: [],
    open: false,
    id: '',
    nome: '',
    ibge: '',
    data_exclusao: '',
    usuario_exclusao: '',
    id_estado: ''
};

export function cidade(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_CIDADE':
            return {
                ...state,
                cidade: action.cidade
            };
        case 'CIDADE_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                ibge: action.ibge,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                id_estado: action.id_estado

            };
        case "CIDADE_UPDATED":
            return state;      
        default:
            return state
    }
}
